import { ConfigProvider } from 'antd';
import { useEffect } from 'react';
import * as styles from '../Workspaces/index.module.scss';
import NewJobsBlock2 from './NewJobsBlock';

interface IProps {
  workspaceId: string;
  name: string;
}

const ShokolatyeCex = ({ workspaceId, name }: IProps) => {
  useEffect(() => {
    document.title = 'Шоколатье';
    return () => {
      document.title = 'Шоколатье';
    };
  }, []);

  return (
    <div className={styles.distributionCenterPage} id="dist-tasks-scroll">
      <div className={styles.distributionCenterPageTop}>
        <div className={styles.title}>{name}</div>
      </div>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
          },
        }}
      >
        <NewJobsBlock2 workspaceId={workspaceId} />
      </ConfigProvider>
    </div>
  );
};

export default ShokolatyeCex;
